var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "31",
      "height": "31"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M.75 30.25v-30h30v30z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M15.75 14.934a3.155 3.155 0 1 1 0-6.31 3.155 3.155 0 0 1 0 6.31m0-12.304a8.83 8.83 0 0 0-8.834 8.834c0 2.196.63 4.253 1.78 6.108 1.198 1.944 2.776 3.61 3.987 5.553.593.946 1.023 1.83 1.477 2.852.328.694.593 1.893 1.59 1.893s1.262-1.199 1.578-1.893c.466-1.022.883-1.906 1.476-2.852 1.212-1.93 2.79-3.597 3.988-5.553 1.161-1.855 1.792-3.912 1.792-6.108A8.83 8.83 0 0 0 15.75 2.63"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }